module.exports = __webpack_public_path__ + "img/full-body.c329e678.svg";